import styled from 'styled-components';

const Main = styled.main`
  flex: 1;

  padding-top: 3rem;
  padding-bottom: 6rem;
`;

export default Main;
